<div class="vehicle-details-header">
    @if(shouldShowInfoIcon) {

    <span class="srp-divider srp-divider--leading" aria-hidden="true"></span>
    <srp-icon icon="info_outline" class="mat_icon" aria-hidden="false" [matMenuTriggerFor]="vehicleDetails"
        (click)="onVehicleDetailsClick()" (keydown.enter)="onVehicleDetailsClick()"
        (keydown.space)="onVehicleDetailsClick()" #menuTrigger="matMenuTrigger"></srp-icon>
    }


    <div class="vehicle-details">
        <span class="srp-header-1">{{vehicleContext.brandDescription}} {{vehicleContext.modelDescription}}</span>
        <span class="srp-header-2">
            @if(vehicleContext.vin) {
            <ng-container>{{ vehicleContext.vin }}</ng-container>
            }
            @if(vehicleContext.vin && (vehicleContext.modelYear || vehicleContext.lpn)) {
            <span class="srp-separator">|</span>

            }
            @if(vehicleContext.modelYear) {
            <ng-container>{{ vehicleContext.modelYear }}</ng-container>

            }
            @if(vehicleContext.modelYear && vehicleContext.lpn) {
            <span class="srp-separator">|</span>

            }

            @if(vehicleContext.lpn) {
            <ng-container>{{ vehicleContext.lpn }}</ng-container>

            }
        </span>
    </div>
</div>


<mat-menu #vehicleDetails="matMenu" class="srp-menu srp-vehicle-details srp-vehicle-model-menu" yPosition="below"
    xPosition="after" hasBackdrop="true" backdropClass="menu-backdrop-blur">
    <!-- Header -->
    <div class="menu-wrapper srp-model-menu-header" disableRipple="true" mat-menu-item
        (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <div>
            <srp-icon icon="close" (click)="closeCart()" (keydown.enter)="closeCart()" tabindex="0"></srp-icon>
        </div>
    </div>
    <!-- Content -->
    <div class="menu-scroll-container srp-model-menu-scroll" (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()">

        <div class="menu-content srp-model-menu-content">
            @if(showPrimaryVehicleCard) {
            <srp-card variant="menu-card" class="mat-card-class">
                <div class="srp-vehicle-card-body">
                    <div class="srp-vehicle-details">
                        <div class="row">
                            @if( vehicleContext.vin) {
                            <span class="vehicle-data-label">{{ (pageContentLabels | contentFilter:LABELS.VIN) || 'VIN'
                                }}</span>
                            <span class="vehicle-data-value">{{ vehicleContext.vin ?? '-'}}</span>
                            }
                        </div>
                        @if( vehicleContext.bodyWork) {
                        <div class="row">
                            <span class="vehicle-data-label">{{ (pageContentLabels | contentFilter:LABELS.BODYWORK) ||
                                'Bodywork' }}</span>
                            <span class="vehicle-data-value">{{ vehicleContext.bodyWork }}</span>
                        </div>
                        }

                        @if(vehicleContext.cubicCapacity ) {
                        <div class="row">
                            <span class="vehicle-data-label">{{ (pageContentLabels |
                                contentFilter:LABELS.CUBIC_CAPACITY) || 'Cubic Capacity' }}</span>
                            <span class="vehicle-data-value">{{ vehicleContext.cubicCapacity}}</span>
                        </div>
                        }

                        @if(vehicleContext.version) {
                        <div class="row">
                            <span class="vehicle-data-label">{{ (pageContentLabels | contentFilter:LABELS.VERSION) ||
                                'Version' }}</span>
                            <span class="vehicle-data-value">{{ vehicleContext.version }}</span>
                        </div>
                        }

                        @if(vehicleContext.engineCode ) {
                        <div class="row">
                            <span class="vehicle-data-label">{{ (pageContentLabels | contentFilter:LABELS.ENGINE_CODE)
                                || 'Engine Code' }}</span>
                            <span class="vehicle-data-value">{{ vehicleContext.engineCode }}</span>
                        </div>
                        }

                        @if( vehicleContext.numberOfDoors ) {
                        <div class="row">
                            <span class="vehicle-data-label">{{ (pageContentLabels | contentFilter:LABELS.NUM_OF_DOORS)
                                || 'Number of Doors' }}</span>
                            <span class="vehicle-data-value">{{ vehicleContext.numberOfDoors ?? '-'}}</span>
                        </div>
                        }

                        @if(vehicleContext.unLadenWeight) {
                        <div class="row">
                            <span class="vehicle-data-label">{{ (pageContentLabels |
                                contentFilter:LABELS.UNLADEN_WEIGHT) || 'Unladen Weight' }}</span>
                            <span class="vehicle-data-value">{{ vehicleContext.unLadenWeight}}</span>
                        </div>
                        }

                        @if(vehicleContext.tireSize && vehicleContext.tireSize.length > 0) {
                        <div class="row">
                            <span class="vehicle-data-label">{{ (pageContentLabels | contentFilter:LABELS.TYRES) ||
                                'Tyres' }}</span>
                            <div class="vehicle-data-value">
                                @for(tyre of vehicleContext.tireSize; track tyre){
                                <span style="display: block;">{{ tyre }}</span>
                                }
                            </div>
                        </div>
                        }

                    </div>
                </div>
            </srp-card>
            }
            @if(showSecondaryVehicleCard) {
            <srp-card variant="menu-card" class="mat-card-class">
                <div class="srp-vehicle-card-body">
                    <div class="srp-vehicle-details">
                        @if ( vehicleContext.brandDescription ) {
                        <div class="row">
                            <span class="vehicle-data-label">{{ (pageContentLabels | contentFilter:LABELS.BRAND) ||
                                'Brand' }}</span>
                            <span class="vehicle-data-value">{{ vehicleContext.brandDescription }}</span>
                        </div>
                        }

                        @if ( vehicleContext.modelDescription ) {
                        <div class="row">
                            <span class="vehicle-data-label">{{ (pageContentLabels | contentFilter:LABELS.MODEL) ||
                                'Model' }}</span>
                            <span class="vehicle-data-value">{{ vehicleContext.modelDescription }}</span>
                        </div>
                        }

                        @if ( vehicleContext.energyCode ) {
                        <div class="row">
                            <span class="vehicle-data-label">{{ (pageContentLabels | contentFilter:LABELS.ENERGY) ||
                                'Energy' }}</span>
                            <span class="vehicle-data-value">{{ vehicleContext.energyCode }}</span>
                        </div>
                        }

                        @if ( vehicleContext.typeOfClutch ) {
                        <div class="row">
                            <span class="vehicle-data-label">{{ (pageContentLabels |
                                contentFilter:LABELS.TYPE_OF_CLUTCH) || 'Type Of Clutch' }}</span>
                            <span class="vehicle-data-value">{{ vehicleContext.typeOfClutch }}</span>
                        </div>
                        }

                        @if ( vehicleContext.powerKW ) {
                        <div class="row">
                            <span class="vehicle-data-label">{{ (pageContentLabels | contentFilter:LABELS.POWER) ||
                                'Power (kW)' }}</span>
                            <span class="vehicle-data-value">{{ vehicleContext.powerKW }}</span>
                        </div>
                        }

                        @if ( vehicleContext.registrationDate ) {
                        <div class="row">
                            <span class="vehicle-data-label">{{ (pageContentLabels | contentFilter:LABELS.FIRST_REG) ||
                                'First Registration' }}</span>
                            <span class="vehicle-data-value">{{ vehicleContext.registrationDate }}</span>
                        </div>
                        }

                    </div>
                </div>
            </srp-card>
            }
        </div>
    </div>
</mat-menu>